import {
  getDefaultUserCredentials,
  getDefaultUserInnocomCredentials,
} from '../../../../utility/utils'

export const users = [
  getDefaultUserCredentials(),
  {
    id: 2,
    companyId: 'qa',
    userName: 'quality_assurance_usr_api',
    password: 's6rq7BQGpdQKCGmmsnjpkf',
  },
  {
    id: 3,
    companyId: 'leasing',
    userName: 'leasing_usr_api',
    password: 's6rq7BQGpdQKCGmmsnjpkf',
  },
  {
    id: 4,
    companyId: 'techy_we',
    userName: 'techy_we', //techy_we
    password: 'Temporal123!',
    userId: 4,
  },
  {
    id: 5,
    companyId: 'airbox',
    userName: 'airbox', //techy_we
    password: 'Temporal123!',
    userId: 5,
  },
  getDefaultUserInnocomCredentials(),
  {
    id: 9,
    companyId: 'global_service',
    userName: 'global_service',
    password: 'Temporal123!',
    userId: 9,
  },
  {
    id: 10,
    companyId: 'camila',
    userName: 'camila',
    password: 'Temporal123!',
    userId: 10,
  },
  {
    id: 11,
    companyId: 'devintech',
    userName: 'devintech',
    password: 'Temporal123!',
    userId: 11,
  },
  {
    id: 12,
    companyId: 'albertodo',
    userName: 'albertodo',
    password: 'Temporal123!',
    userId: 12,
  },
  {
    id: 13,
    companyId: 'iberojet',
    userName: 'iberojet',
    password: 'Temporal123!',
    userId: 10,
  },
  {
    id: 14,
    companyId: 'unillantas',
    userName: 'unillantas',
    password: 'Temporal123!',
    userId: 16,
  },
]
